import { formatDate } from "@angular/common";
import { Injectable } from "@angular/core";

@Injectable()
export class FormatDeployLabelService {
  public labelFor(deploy: any) {
    const date = formatDate(deploy.createdAt, "yyyy-MM-dd", "en-US");

    if (deploy.version) {
      return `${date} version: ${deploy.version.slice(0, 8)}`;
    }
    if (deploy.revision) {
      return `${date} rev: ${deploy.revision.slice(0, 8)}`;
    }

    return date;
  }
}
